import { forwardRef } from "react";
import ReactSelect from "react-select";

// Rich dropdown styled to the Form Field spec via the peb-rs class prefix.
// The wrapper carries the error state so .peb-rs--error can target the control.
// `as` swaps the react-select variant (Creatable, AsyncSelect) while keeping the styling.
const Select = forwardRef(function Select({ as: Component = ReactSelect, error = false, className = "", "data-testid": testId, ...rest }, ref) {
  return (
    <div className={`peb-rs ${error ? "peb-rs--error" : ""} ${className}`} data-testid={testId}>
      <Component ref={ref} classNamePrefix="peb-rs" {...rest} />
    </div>
  );
});

export default Select;
